import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import {
  activeProcessSF,
  getActiveProcessKey,
  handleProcess,
  IRydeProcess,
  RydeProcessTitle,
  RydeUiUnit,
  supportsBulkSummaryToast,
  TAddressedFieldsValueOnCompleted,
  useProcesses,
} from "@ryde/shared";

export const useWatchBulkSetNearby = ({
  entity,
  addressedFieldsValueOnCompleted,
}: {
  entity: RydeUiUnit;
  addressedFieldsValueOnCompleted: TAddressedFieldsValueOnCompleted;
}) => {
  const bulkSetNearByProcessKey = getActiveProcessKey(
    RydeProcessTitle.BulkSetPassengersNearBy,
    entity,
  );

  const bulkSetNearByProcess = useRecoilValue(
    activeProcessSF(bulkSetNearByProcessKey),
  );
  const { stopProcessPolling } = useProcesses();
  const { t } = useTranslation();

  const onComplete = useCallback(
    (process: IRydeProcess) => {
      addressedFieldsValueOnCompleted(process);
    },
    [addressedFieldsValueOnCompleted],
  );

  useEffect(() => {
    handleProcess({
      entity,
      processTitle: RydeProcessTitle.BulkSetPassengersNearBy,
      process: bulkSetNearByProcess,
      onComplete,
      translationFunction: t,
      stopProcessPolling,
      toastSummaryOnComplete: supportsBulkSummaryToast(entity),
    });
  }, [bulkSetNearByProcess, entity, onComplete, stopProcessPolling, t]);
};
